var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-root"},[_c('div',{attrs:{"aria-hidden":_vm.showMobileAccessNotice ? 'true' : null}},[_c('router-view')],1),(_vm.showMobileAccessNotice)?_c('MobileAccessNotice',{on:{"acknowledge":_vm.acknowledgeMobileAccess}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }